<div class="container py-5">
  <div class="card border-left">
    <h1 class="text-primary fw-bold text-center">
      AVISO DE PAGO PENDIENTE
    </h1>

    <p class="text-3xl fw-bold">
      Estimado cliente de <strong>Pestforce</strong>,
    </p>

    <p class="text-xl">
      Nos hemos dado cuenta de que su cuenta presenta un saldo pendiente. Para continuar disfrutando del acceso completo
      a
      nuestros servicios, incluyendo certificados, reportes, cotizaciones y otros documentos, le pedimos amablemente que
      regularice su situación de pago.
    </p>

    <h2 class="text-3xl fw-bold">¿Necesita ayuda?</h2>

    <p class="text-xl">
      Si tiene alguna duda sobre su situación o necesita asistencia con el proceso de pago, nuestro equipo de soporte
      está
      disponible para ayudarle. Contáctenos a través de:
    </p>

    <ul>
      <li>
        <strong>Correo electrónico:</strong>
        <a href="mailto:soporte@pestforce.com">
          {{ 'soporte@pestforce.com' }}
        </a>
      </li>

      <li>
        <strong>Teléfono:</strong> +52 449 911 904
      </li>
    </ul>

    <p class="text-xl">
      Agradecemos su pronta atención a este asunto y su compromiso con <strong>Pestforce</strong>. Esperamos resolver
      esta
      situación para que pueda seguir utilizando nuestros servicios sin interrupciones.
    </p>
  </div>
</div>